import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmationDialog } from '../../ui';

/**
 * Confirmation dialog for sending a request payment to a client whose sms is disabled
 */

export default function RequestPaymentDisabledDialog(props) {
  const {
    onConfirm,
  } = props;

  return (
    <ConfirmationDialog
      show
      title="Your client must turn on text notifications to be eligible for payment requests"
      description={
        'To charge your client for this appointment,'
        + 'update the payment method and check out manually.\n\n'
        + 'You can invite clients to turn on text notifications from client details.'
      }
      confirmText="Got it"
      onConfirm={onConfirm}
    />
  );
}

RequestPaymentDisabledDialog.propTypes = {
  /** Callback fired when the confirm button is clicked. */
  onConfirm: PropTypes.func.isRequired,
};
